import isFuture from 'date-fns/is_future'
import addDays from 'date-fns/add_days'

const checkInvalidBPItem = billingPeriod => {
  const startTime = billingPeriod.startTime
  // 当日のデータがなくてエラーになる可能性もあるので、BP 開始から1日経たないと選択できない
  return isFuture(addDays(startTime, 1))
}

export default checkInvalidBPItem
